import { LoadingAnimation } from '@outbound-ai/ursa'
import { SetStateAction, useState } from 'react'
import { FaTrashAlt } from 'react-icons/fa'
import { Button, ObModal } from '@outbound-ai/ursa'
import styled from 'styled-components'
import { notificator } from 'utils/notificator/notificator'

import { useAppDispatch } from 'appState/store'
import { updateCurrentFiles } from '../FileShareSlice'
import { FileShareTabType } from '../types/FileShareEnums'
import { fileShareDeleteFile } from '../utils/fileShareApi'
import { createFileShareServerSideDataSource } from '../utils/grid'

export const DeleteFile = (params: any) => {
  const dispatch = useAppDispatch()

  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  const handelDeleteFile = () => {
    setLoading(true)
    fileShareDeleteFile(params.data.fileExchangeId)
      .then((res) => {
        if (res) {
          setShow(false)
          setLoading(false)
          dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: true }))
          const dataSource = createFileShareServerSideDataSource()
          params.api.setGridOption('serverSideDatasource', dataSource)

          notificator.notify({
            type: 'info',
            heading: 'Successfully deleted the file',
          })

          //notificator.info(`Successfully deleted the file `)
        }
      })
      .catch(() => {
        notificator.notify({
          type: 'error',
          heading: 'Failed to delete the file',
        })
        //notificator.error('Failed to delete the file')
        setShow(false)
        setLoading(false)
        dispatch(updateCurrentFiles({ root: FileShareTabType.Files, refresh: true }))
        const dataSource = createFileShareServerSideDataSource()
        params.api.setGridOption('serverSideDatasource', dataSource)
      })
  }

  const handelClose = (params: any, setShow: { (value: SetStateAction<boolean>): void; (arg0: boolean): void }) => {
    setShow(false)
    const dataSource = createFileShareServerSideDataSource()
    params.api.setGridOption('serverSideDatasource', dataSource)
  }

  return (
    <Div>
      <Button
        variant="danger-outline"
        size="small"
        radius="rounded"
        onClick={() => {
          setShow(true)
        }}
      >
        <FaTrashAlt />
      </Button>

      <ObModal
        show={show}
        size="lg"
        customSize="small"
        close={() => setShow(false)}
        title={'Delete file?'}
        modalFooter={
          <ModalFooter>
            <Button
              variant="danger-outline"
              size="normal"
              radius="rounded"
              onClick={() => handelDeleteFile()}
              width="100%"
            >
              {loading ? (
                <>
                  <LoadingAnimation variant="danger" />
                </>
              ) : (
                'Yes, delete'
              )}
            </Button>
            <Button
              width="100%"
              variant="primary"
              size="normal"
              radius="rounded"
              contentType="text-icon"
              onClick={() => handelClose(params, setShow)}
            >
              No, cancel
            </Button>
          </ModalFooter>
        }
      >
        Are you sure you want to delete this file? This action cannot be undone.
      </ObModal>
    </Div>
  )
}

const Div = styled.div``

const ModalFooter = styled.div`
  flex-wrap: nowrap;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
`
